import React, { useState } from "react";
import { Customer } from "../../helpers/Responses";
import "twin.macro";
import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import Button from "../../components/Button";
import Api from "../../helpers/Api";
import { useQueryClient } from "react-query";
import { AddressView } from "../../components/AppComponents";
import moment from "moment";

interface CustomerDetailProps {
  customer?: Customer | null;
  onClose?: () => void;
}

export default function CustomerDetail(props: CustomerDetailProps) {
  const queryClient = useQueryClient();
  const { state } = useContext(AppContext);
  const { customer } = props;
  const [value, setValue] = useState<Record<string, boolean>>(() => {
    let map: Record<string, boolean> = {};
    customer?.groups?.forEach(g => map[g.id] = true)
    return map;
  });
  const [loading, setLoading] = useState(false);

  const groups = state.options.customerGroups;
  const isEditableForm = groups?.length > 0;

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { value, checked } = event.target;
    console.log(event.target);
    setValue(v => ({ ...v, [value]: checked }))
  }

  async function handleSave() {
    if (!customer || isEditableForm) return;
    setLoading(true);

    let selectedGroups = Object.entries(value).filter(([k, v]) => v).map(([k]) => ({ id: k }));

    let res = await Api.updateCustomer(customer.id, { groups: selectedGroups })
    setLoading(false);
    if (res.status === 200) {
      queryClient.invalidateQueries('listCustomers');
      props.onClose && props.onClose()
    }
  }

  if (!customer) return null;

  return (
    <div>
      <table>
        <tr>
          <td tw="font-semibold pr-2 align-top">Name</td>
          <td>{customer.name}</td>
        </tr>
        <tr>
          <td tw="font-semibold pr-2 align-top">Mobile</td>
          <td>{customer.mobile}</td>
        </tr>
        <tr>
          <td tw="font-semibold pr-2 align-top">Email</td>
          <td>{customer.email}</td>
        </tr>
        <tr>
          <td tw="font-semibold pr-2 align-top">Address</td>
          <td>
            <AddressView data={customer.address} style={{ }} />
          </td>
        </tr>
        <tr>
          <td tw="font-semibold pr-2 align-top">Registered On</td>
          <td>{moment(customer.createdAt).format('DD MMM YYYY')}</td>
        </tr>
      </table>
      {isEditableForm ?
        <>
          <hr tw="my-2 border-gray-300" />
          <h3 tw="font-semibold">Customer Groups</h3>
          <p tw="text-sm text-gray-500">Pricing applied to group will be applicable for the user.</p>
          {groups?.map(g => (
            <label key={g.value} tw="block my-2">
              <input
                type="checkbox"
                value={g.value}
                onChange={handleChange}
                checked={value[g.value]}
              />
              <span tw="ml-2">{g.label}</span>
            </label>
          ))}
        </> : <></>
      }
      <div tw="flex justify-end">
        <Button onClick={props.onClose} variant="secondary">{isEditableForm ? 'Cancel' : 'Close'}</Button>
        {isEditableForm &&
          <Button onClick={handleSave} loading={loading}>Save</Button>
        }
      </div>
    </div>
  )
}